import type { ProductType } from '@features/catalog/types';

type HoldingStatusWithNone = 'active' | 'expiring' | 'expired' | 'none';

export const productTypeColor: Record<ProductType, string> = {
  AVCS: '#DF017C',
  ADP: '#84B0B5',
  'e-NP': '#7476B7',
};

export const productTypeLabel: Record<ProductType, string> = {
  AVCS: 'AVCS',
  ADP: 'ADP',
  'e-NP': 'ENP',
};

/** Chip sx overrides for product-type filter chips. Returns {} for "All". */
export function productTypeChipSx(value: string, selected: boolean): Record<string, unknown> {
  const color = productTypeColor[value as ProductType];
  if (!color) return {};
  if (selected) {
    return {
      bgcolor: color,
      color: 'common.white',
      '&:hover': { bgcolor: color, filter: 'brightness(0.9)' },
    };
  }
  return { borderColor: color, color };
}

export const holdingDotColor: Record<HoldingStatusWithNone, string> = {
  active: 'success.main',
  expiring: 'warning.main',
  expired: 'error.main',
  none: 'text.disabled',
};

export const holdingLabel: Record<HoldingStatusWithNone, string> = {
  active: 'Active',
  expiring: 'Expiring',
  expired: 'Expired',
  none: 'Not in holdings',
};
